import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { NumeroDocumentoInput } from 'sharedComponents/inputs/text'

import { KeyEventUtil } from 'utils'

const NumeroDocumentoFormGroup = ({ iTouched, iError, fIsSubmitting, vMoneda }) => {
  const onKeyDown = React.useCallback(
    e => {
      if (vMoneda === '') {
        KeyEventUtil.leaveOnEnterOrTab('select-moneda', e)
      } else {
        KeyEventUtil.leaveOnEnterOrTab('input-importe', e)
      }
    },
    [vMoneda]
  )

  return (
    <Form.Group>
      <Form.Label text='N° DOC' htmlFor='input-numeroDocumento' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='numeroDocumento'>
          {({ field }) => (
            <NumeroDocumentoInput
              {...field}
              id='input-numeroDocumento'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroDocumentoFormGroup)
